/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_LivesInputs */

const bn_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাস করে`)
};

const de_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leben`)
};

const el_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ζωές`)
};

const en_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lives`)
};

const es_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidas`)
};

const fr_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vies`)
};

const hi_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़िंदगियाँ`)
};

const hu_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Életek`)
};

const id_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidup`)
};

const it_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vite`)
};

const ja_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生きる`)
};

const ko_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생활`)
};

const nl_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levens`)
};

const pl_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żyje`)
};

const pt_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidas`)
};

const ru_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жизни`)
};

const sv_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bor`)
};

const tr_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yaşıyor`)
};

const uk_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`життя`)
};

const vi_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuộc sống`)
};

const zh_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生活`)
};

const zh_hant_game_stat_lives = /** @type {(inputs: Game_Stat_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生活`)
};

/**
* | output |
* | --- |
* | "Lives" |
*
* @param {Game_Stat_LivesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_lives = /** @type {((inputs?: Game_Stat_LivesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_LivesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_lives(inputs)
	if (locale === "de") return de_game_stat_lives(inputs)
	if (locale === "el") return el_game_stat_lives(inputs)
	if (locale === "en") return en_game_stat_lives(inputs)
	if (locale === "es") return es_game_stat_lives(inputs)
	if (locale === "fr") return fr_game_stat_lives(inputs)
	if (locale === "hi") return hi_game_stat_lives(inputs)
	if (locale === "hu") return hu_game_stat_lives(inputs)
	if (locale === "id") return id_game_stat_lives(inputs)
	if (locale === "it") return it_game_stat_lives(inputs)
	if (locale === "ja") return ja_game_stat_lives(inputs)
	if (locale === "ko") return ko_game_stat_lives(inputs)
	if (locale === "nl") return nl_game_stat_lives(inputs)
	if (locale === "pl") return pl_game_stat_lives(inputs)
	if (locale === "pt") return pt_game_stat_lives(inputs)
	if (locale === "ru") return ru_game_stat_lives(inputs)
	if (locale === "sv") return sv_game_stat_lives(inputs)
	if (locale === "tr") return tr_game_stat_lives(inputs)
	if (locale === "uk") return uk_game_stat_lives(inputs)
	if (locale === "vi") return vi_game_stat_lives(inputs)
	if (locale === "zh") return zh_game_stat_lives(inputs)
	return zh_hant_game_stat_lives(inputs)
});